import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  GetEnumValuesDto,
  SendTypes,
  UpdateWhiteMessageStatusCommand,
  WhiteMessageByIdDto,
  WhiteMessageStatus,
} from 'src/app/core/api/models';
import { WhiteMessagesService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { FormPageConfig } from 'src/app/core/models/form-page-config.model';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';


@Component({
    selector: 'app-white-message-form',
    templateUrl: './white-message-form.component.html',
    styleUrls: ['./white-message-form.component.scss'],
    imports: [BaseFormModule]
})
export class WhiteMessageFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties

  formPageConfig: FormPageConfig<WhiteMessageByIdDto> = {};
  model: UpdateWhiteMessageStatusCommand = {};
  get SendTypes() {
    return SendTypes;
  }
  get WhiteMessageStatus() {
    return WhiteMessageStatus;
  }

  whiteMsgDetail: WhiteMessageByIdDto;
  @Input('phonebookTypes') phonebookTypesEnumValues: GetEnumValuesDto[] = [];

  //#endregion

  constructor(protected currentService: WhiteMessagesService) {
    super();
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl(''),
      userName: new FormControl(''),
      privateNumber: new FormControl(''),
      cancelText: new FormControl(''),
      enterSms: new FormControl(''),
      exitSms: new FormControl(''),
      returnText: new FormControl(''),

      status: new FormControl('', Validators.required),
      privateNumberId: new FormControl(''),
      dailyAddLimit: new FormControl(''),
      monthlyAddLimit: new FormControl(''),
      isSendCancelText: new FormControl(''),
      repeatTextDay: new FormControl(''),
      rejectComment: new FormControl(''),
    });
  }

  changeValidation() {
    if (this.whiteMsgDetail.status == WhiteMessageStatus.Reject) {
      this.form.get('rejectComment').addValidators(Validators.required);
      this.form.get('privateNumberId').clearValidators();
    }
    if (this.whiteMsgDetail.status == WhiteMessageStatus.Confirmed) {
      this.form.get('privateNumberId').addValidators(Validators.required);
      this.form.get('rejectComment').clearValidators();
    }
    this.form.updateValueAndValidity();
  }

  ngOnInit() {
    super.ngOnInit();
    this.changeValidation();
  }

  initModel() {
    try {
      this.whiteMsgDetail = Object.assign({}, this.formPageConfig.editData);
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }

  //#region api

  //Create
  baseCreateApi(model: any) {}

  //Update
  baseUpdateApi(model: UpdateWhiteMessageStatusCommand) {
    this.unSubs();
    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .whiteMessagesUpdateWhiteMessageStatusPut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit(): void {
    try {
      this.model = {
        id: this.formPageConfig.editId,
        dailyAddLimit: this.whiteMsgDetail.dailyAddLimit,
        isSendCancelText: this.whiteMsgDetail.isSendCancelText,
        monthlyAddLimit: this.whiteMsgDetail.monthlyAddLimit,
        privateNumberId: this.whiteMsgDetail.privateNumberId,
        rejectComment: this.whiteMsgDetail.rejectComment,
        repeatTextDay: this.whiteMsgDetail.repeatTextDay,
        status: this.whiteMsgDetail.status,
      };
      super.onSubmit();
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.whiteMessages
      );
    }
  }
}
